import React from 'react'
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import { FaFileAlt } from "react-icons/fa";

const AllDocument = () => {
    const navigate = useNavigate();

    const documentTypeList = [
        { value: 'job-offer', label: <><FaFileAlt className="me-2 text-primary" /> Job Offer</> },
        { value: 'appointment-letter', label: <><FaFileAlt className="me-2 text-success" /> Appointment Letter</> },
        { value: 'confirmation', label: <><FaFileAlt className="me-2 text-info" /> Job Confirmation</> },
        { value: 'salary-increment', label: <><FaFileAlt className="me-2 text-warning" /> Salary Increment</> },
        { value: 'separation', label: <><FaFileAlt className="me-2 text-danger" /> Job Separation</> },
        { value: 'posting', label: <><FaFileAlt className="me-2 text-primary" /> Posting</> },
        { value: 'termination-notice', label: <><FaFileAlt className="me-2 text-danger" /> Termination Notice</> },
        { value: 'change-designation', label: <><FaFileAlt className="me-2 text-secondary" /> Change of Designation</> },
        { value: 'code-conduct', label: <><FaFileAlt className="me-2 text-dark" /> Code of Conduct</> },
        { value: 'disciplinary-warning', label: <><FaFileAlt className="me-2 text-danger" /> Disciplinary Warning</> },
        { value: 'appriciation', label: <><FaFileAlt className="me-2 text-info" /> Appreciation</> },
        { value: 'testimonial', label: <><FaFileAlt className="me-2 text-success" /> Testimonial</> },
        { value: 'advance', label: <><FaFileAlt className="me-2 text-primary" /> Advance</> },
        { value: 'reference', label: <><FaFileAlt className="me-2 text-warning" /> Reference</> },
        // { value: 'Ref. Request', label: <><FaFileAlt className="me-2 text-warning" /> Ref. Request</> }
    ]

    // ===============handlers===================
    const handleChange = (selectedOption) => {
        navigate(`/admin/documents/${selectedOption.value}`);
    }

    return (
        <>
            <div className='main-section'>
                <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                    <h3 className='my-3 fw-bold fs-5 golos'>HR Documents</h3>

                    {/* PAGE TITLE */}
                    <h2 className="text-center mb-4 fw-bold text-success">
                        HR Document Generator
                    </h2>

                    {/* CARD BOX */}
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-8 col-lg-7">

                            <div className="card shadow-sm p-4 border-0">
                                <div className="card-body">

                                    <h5 className="card-title fw-semibold mb-3 text-black text-center">
                                        Select Document Type
                                    </h5>

                                    <Select
                                        options={documentTypeList}
                                        onChange={handleChange}
                                        className="basic-select"
                                        classNamePrefix="select"
                                    />

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AllDocument